var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 49 49"
    },
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3 6.5H9.7A9.8 9.8 0 0 0 0 16.3v16.4c0 5.4 4.4 9.8 9.7 9.8h29.6c5.3 0 9.7-4.4 9.7-9.8V16.3c0-5.4-4.4-9.8-9.7-9.8zM47 32.7c0 4.3-3.5 7.8-7.7 7.8H9.7A7.8 7.8 0 0 1 2 32.7V16.3C2 12 5.5 8.5 9.7 8.5h29.6c4.2 0 7.7 3.5 7.7 7.8v16.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m33.4 24.1-13.9-8a1 1 0 0 0-1.5.8V33a1 1 0 0 0 1.5.9l13.9-8.1a1 1 0 0 0 0-1.8zM20 31.4V18.6L30.9 25 20 31.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a9b83fa789d687c18676bed310fc4bec.svg";
export { ForwardRef as ReactComponent };